<template>
  <div>
    <el-form
        class="demo-ruleForm"
        ref="lform"
        :model="form"
        :rules="rules"
        label-width="0">
      <el-form-item prop="name">
        <el-input v-model="form.account" placeholder="证件号码">
          <img slot="prefix" class="login-Icon" src="@/assets/slices/user.png"/>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="form.password" autocomplete="off" placeholder="登录密码">
          <img slot="prefix" class="login-Icon" src="@/assets/slices/lock.png"/>
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="captchaEnabled">
        <el-input v-model="form.code" auto-complete="off" placeholder="验证码">
          <img slot="prefix" class="login-Icon" src="@/assets/slices/security-safe.png"/>
          <img slot="suffix" :src="codeUrl" class="login-code" @click="getCode"/>
        </el-input>
      </el-form-item>
      <div class="mb15 flex ju-en">
        <el-checkbox v-model="checked">记住密码</el-checkbox>
      </div>
      <el-form-item>
        <el-button
            :loading="loading"
            :disabled="loading"
            size="medium"
            type="danger"
            round
            @click="login"
            style="width:100%;background-color: #C32912;color: #fff">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
      <div class="flex al-cn ju-cn f14 cl999">
        <div class="flex al-cn pointer">
          <div class="clC32912" @click="toggle('用户注册')">注册账号</div>
          <div class="plr10">|</div>
          <div class="cl000" @click="toggle('找回密码')">忘记密码</div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import {login} from "@/api/api";

export default {
  name: "login",
  props: {
    codeUrl: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      loading: false,
      form: {
        account: "",
        password: "",
        code: "",
      },
      rules: {
        account: [{required: true, message: "请输入账号", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"},],
        code: [{required: true, message: "请输入验证码", trigger: "blur"}],
      },
      checked: false,
      // 验证码开关
      captchaEnabled: true,
    }
  },
  mounted() {

  },
  methods: {
    // 获取验证码
    getCode() {
      this.$emit('getCode');
    },
    // 切换
    toggle(e) {
      this.$emit('toggle', e);
    },
    // 登录
    login() {
      this.$refs.lform.validate(valid => {
        if (valid) {
          this.loading = true;
          login(this.form).then(res => {
            this.loading = false;
            if (res.status === 200){
              sessionStorage.setItem("token", res.data.token);
              this.$store.commit('setToken', res.data.token)
              this.resetForm('lform')
            }
          }).catch(e => {
            this.loading = false;
            this.getCode()
            console.log('请求错误', e)
            this.$message({
              message: e || '网络或程序异常！',
              type: "error"
            });
          });
        } else {
          this.$message({
            message: "请输入合法的值",
            type: "error"
          });
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    }
  }
}
</script>
<style scoped lang="scss">

</style>
